/**
 * General app strings
 *
 * NOTE - Deployment-specific strings should be specified in environment files, not here",
 */
export default {
  "HOME_PAGE_TITLE": "IDEMS Media Recorder"
}
